import { render, staticRenderFns } from "./TestEnd.vue?vue&type=template&id=35394beb&"
import script from "./TestEnd.vue?vue&type=script&lang=js&"
export * from "./TestEnd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports